import React from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';

const TabsContentListSwipeableLayout = ({
  children,
  index,
  onChangeIndex,
  isSwipePrevented = false,
}) => {
  const swipeableContainerStyle = {
    height: '100%',
    boxSizing: 'border-box',
  };

  return (
    <SwipeableViews
      axis="x"
      animateTransitions
      enableMouseEvents
      index={index}
      onChangeIndex={onChangeIndex}
      containerStyle={swipeableContainerStyle}
      className="ws-ui-tabs__content-list-layout"
      disabled={isSwipePrevented}
    >
      {children}
    </SwipeableViews>
  );
};

TabsContentListSwipeableLayout.propTypes = {
  children: PropTypes.node.isRequired,
  index: PropTypes.number.isRequired,
  onChangeIndex: PropTypes.func.isRequired,
  isSwipePrevented: PropTypes.bool,
};

export default TabsContentListSwipeableLayout;
